// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channelnotifications.js.

const channels = require.context('.', true, /_channel\notifications.js$/);
channels.keys().forEach(channels);
